// The catalog row that holds a person's time zone (migration 0065).

/** The Preference: the IANA zone a person usually works in; its default is the organization's. */
export const PRIMARY_TIME_ZONE_PREFERENCE_KEY = 'primary_time_zone'
